import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function VisitConfirmPage() {
  const { id } = useParams();
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState(null);
  const [geoStatus, setGeoStatus] = useState('pending'); // 'pending', 'success', 'fail', 'denied'
  const [geoData, setGeoData] = useState(null);

  // --- Geolokacija ---
  useEffect(() => {
    let finished = false;

    // Zahtev za geolokaciju (timeout za fallback)
    const geoTimeout = setTimeout(() => {
      if (!finished) {
        setGeoStatus('fail');
        setGeoData(null);
        sendConfirm(null); // šalje bez geolokacije
      }
    }, 10000); // 10s timeout

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => {
          finished = true;
          clearTimeout(geoTimeout);
          setGeoStatus('success');
          setGeoData({
            lat: pos.coords.latitude,
            lon: pos.coords.longitude,
            accuracy: pos.coords.accuracy
          });
          sendConfirm({
            lat: pos.coords.latitude,
            lon: pos.coords.longitude,
            accuracy: pos.coords.accuracy
          });
        },
        err => {
          finished = true;
          clearTimeout(geoTimeout);
          setGeoStatus('denied');
          setGeoData(null);
          sendConfirm(null); // šalje bez geolokacije
        },
        { enableHighAccuracy: true, timeout: 9000 }
      );
    } else {
      setGeoStatus('fail');
      setGeoData(null);
      sendConfirm(null); // šalje bez geolokacije
    }

    function sendConfirm(geo) {
      // Skupi još dodatne podatke (browser info)
      const extra_data = {
        platform: navigator.platform,
        userAgent: navigator.userAgent,
        language: navigator.language,
        screen: { w: window.screen.width, h: window.screen.height },
        accuracy: geo?.accuracy || null
      };
      axios.post(`/api/visits/${id}/confirm`, {
        lat: geo?.lat,
        lon: geo?.lon,
        extra_data
      })
        .then(() => setConfirmed(true))
        .catch(err => setError(err.response?.data?.message || 'Failed'));
    }

    // cleanup
    return () => clearTimeout(geoTimeout);
  }, [id]);

  return (
    <div className="p-6 text-center">
      {confirmed ? (
        <>
          <h2 className="text-2xl font-bold text-green-600">✅ Visit Confirmed</h2>
          <p className="mt-2 text-gray-700">Thank you for confirming the session.</p>
          {geoStatus === 'success' && geoData && (
            <div className="mt-2 text-xs text-gray-500">
              Location captured: {geoData.lat.toFixed(5)}, {geoData.lon.toFixed(5)}
            </div>
          )}
          {geoStatus === 'denied' && (
            <div className="mt-2 text-xs text-orange-500">
              Location access denied, but confirmation recorded.
            </div>
          )}
        </>
      ) : error ? (
        <>
          <h2 className="text-2xl font-bold text-red-600">⚠️ Confirmation Failed</h2>
          <p className="mt-2 text-gray-700">{error}</p>
        </>
      ) : (
        <>
          <h2 className="text-2xl font-bold text-blue-600">Processing Confirmation...</h2>
          <p className="mt-2 text-gray-700">
            {geoStatus === 'pending' && 'Requesting permission to access your location for validation...'}
            {geoStatus === 'success' && 'Location obtained. Please wait...'}
            {geoStatus === 'denied' && 'Location not provided. Confirmation in progress...'}
            {geoStatus === 'fail' && 'Could not access location. Confirmation in progress...'}
          </p>
        </>
      )}
    </div>
  );
}

export default VisitConfirmPage;


